import { List, MessageSquare, Wrench } from 'lucide-react';
import { useEffect, useState } from 'react';
import { site } from '@/content/et/site';
import styles from './StickyMobileCTA.module.css';

type NavKey = 'teenused' | 'hinnakiri' | 'kontakt';

const items: {
  key: NavKey;
  href: string;
  label: string;
  sectionId: string;
  Icon: typeof Wrench;
}[] = [
  {
    key: 'teenused',
    href: '/#teenused',
    label: site.sticky.services,
    sectionId: 'teenused',
    Icon: Wrench,
  },
  {
    key: 'hinnakiri',
    href: '/#hinnakiri-cards',
    label: site.sticky.pricing,
    sectionId: 'hinnakiri-cards',
    Icon: List,
  },
  {
    key: 'kontakt',
    href: '/#kontakt',
    label: site.sticky.contact,
    sectionId: 'kontakt',
    Icon: MessageSquare,
  },
];

export function StickyMobileCTA() {
  const [active, setActive] = useState<NavKey | null>(null);

  useEffect(() => {
    const update = () => {
      const probeY = window.innerHeight * 0.35;
      let current: NavKey = 'teenused';

      for (const item of items) {
        const el = document.getElementById(item.sectionId);
        if (!el) continue;
        if (el.getBoundingClientRect().top <= probeY) {
          current = item.key;
        }
      }

      setActive(current);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return (
    <nav className={styles.bar} aria-label="Kiirtoimingud">
      {items.map(({ key, href, label, Icon }) => {
        const isActive = active === key;
        return (
          <a
            key={key}
            href={href}
            className={[styles.item, isActive ? styles.active : '']
              .filter(Boolean)
              .join(' ')}
            aria-current={isActive ? 'true' : undefined}
          >
            <Icon size={22} strokeWidth={1.75} aria-hidden />
            {label}
          </a>
        );
      })}
    </nav>
  );
}
